/**
 * Go 代码生成器
 * 生成使用 net/http 的 Go HTTP 请求代码
 */

import { BaseCodeGenerator } from './base.js';

export class GoGenerator extends BaseCodeGenerator {
  constructor() {
    super({
      language: 'go',
      library: 'net/http',
      indent: '\t',
      maxLineLength: 80
    });
  }

  generate(parsedCurl) {
    this.validateParsedCurl(parsedCurl);

    const lines = [];
    lines.push('package main');
    lines.push('');
    lines.push('import (');
    lines.push('\t"fmt"');
    lines.push('\t"io"');
    lines.push('\t"net/http"');
    if (parsedCurl.data.type !== 'none') {
      lines.push('\t"strings"');
    }
    lines.push(')');
    lines.push('');
    lines.push('func main() {');
    lines.push(`\t${this.generateComment(`发送 ${parsedCurl.method} 请求到 ${parsedCurl.url}`)}`);
    
    if (parsedCurl.data.type !== 'none') {
      lines.push(`\tdata := strings.NewReader("${this.escapeString(parsedCurl.data.content)}")`);
      lines.push(`\treq, err := http.NewRequest("${parsedCurl.method}", "${this.escapeString(parsedCurl.url)}", data)`);
    } else {
      lines.push(`\treq, err := http.NewRequest("${parsedCurl.method}", "${this.escapeString(parsedCurl.url)}", nil)`);
    }
    
    lines.push('\tif err != nil {');
    lines.push('\t\tfmt.Println(err)');
    lines.push('\t\treturn');
    lines.push('\t}');

    if (Object.keys(parsedCurl.headers).length > 0) {
      lines.push('');
      Object.entries(parsedCurl.headers).forEach(([key, value]) => {
        lines.push(`\treq.Header.Set("${this.escapeString(key)}", "${this.escapeString(value)}")`);
      });
    }

    lines.push('');
    lines.push('\tclient := &http.Client{}');
    lines.push('\tresp, err := client.Do(req)');
    lines.push('\tif err != nil {');
    lines.push('\t\tfmt.Println(err)');
    lines.push('\t\treturn');
    lines.push('\t}');
    lines.push('\tdefer resp.Body.Close()');
    lines.push('');
    lines.push('\tfmt.Println("Status:", resp.Status)');
    lines.push('');
    lines.push('\tbody, err := io.ReadAll(resp.Body)');
    lines.push('\tif err != nil {');
    lines.push('\t\tfmt.Println(err)');
    lines.push('\t\treturn');
    lines.push('\t}');
    lines.push('');
    lines.push('\tfmt.Println(string(body))');
    lines.push('}');

    return lines.join('\n');
  }

  generateComment(text) {
    return `// ${text}`;
  }

  escapeString(str) {
    return str
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"')
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r')
      .replace(/\t/g, '\\t');
  }
}